import { createContext, useContext } from 'react'

import { KeyedMutator } from 'swr'

import { User } from '@driftt/api-types'

import { SWRUser } from 'api/report/realTime/types'

import { ModalType } from '../components/DrilldownModal/useDrilldownConfig'
import { TeamsWithMemberInfo } from '../hooks/useTeamsWithMembers'

export interface RTDContextData {
  isSalesView: boolean
  teams: TeamsWithMemberInfo
  allUsers: Record<string, SWRUser>
  bot: User | undefined
  filteredAgents: string[]
  teamsWithMembersRefresh: KeyedMutator<User[]>
}

function createRTDContext<A extends Record<string, any> | null>() {
  const ctx = createContext<A | undefined>(undefined)
  function useCtx() {
    const c = useContext(ctx)
    if (c === undefined)
      throw new Error('useCtx must be inside a Provider with a value')
    return c
  }
  return [useCtx, ctx.Provider] as const // 'as const' makes TypeScript infer a tuple
}

export const [useRTDContext, RTDContextProvider] =
  createRTDContext<RTDContextData>() // specify type, but no need to specify value upfront!

export interface RTDModalContextData {
  currentModal: ModalType
  handleModalToggle: (key: string, source: string) => void
  openModalWithTeam: (number) => void
  openModalWithUser: (number) => void
  drilldownCellOnClick: (number, modalType, isTeamChart) => void
}

export const [useRTDModalContext, RTDModalContextProvider] =
  createRTDContext<RTDModalContextData>() // specify type, but no need to specify value upfront!
